app.controller("completeController", [
	"$scope",
	"$timeout",
	"UserService",
	"ReferralsAPI",
	"CurrentPatient",
	"CurrentReferral",
	"$state",
	"$rootScope",
	"$modal",
	'$window',
	"Session",
	"Insurance",
	"IMPACT_ON_LIFE_VALID_MONTHS",
	function($scope, $timeout, UserService, ReferralsAPI, CurrentPatient, CurrentReferral, $state, $rootScope, $modal, $window, Session, Insurance, IMPACT_ON_LIFE_VALID_MONTHS) {
		$scope.CP = CurrentPatient;
		$scope.RA = ReferralsAPI;
		$scope.CR = CurrentReferral;
		$scope.US = UserService;
		$scope.Session = Session;
		$scope.doctorsArray = [];
		$scope.doctorsDhbArray = [];
		$scope.displayOptomsArray = [];
		$scope.override = {};
		$scope.eligible = {};
		$scope.eligible.private = true;
		$scope.showDocWarning = false;

		// When a patient's DHB can't be resolved from their address the backend
		// returns an "Unknown DHB" that has a name but no code, so fall back to the
		// name for matching (as referralScreenController does).
		var outcomeDhb = ($scope.CR.referral && $scope.CR.referral.outcome && $scope.CR.referral.outcome.dhb) || {};
		$scope.dhbName = outcomeDhb.name;
		$scope.dhbCode = outcomeDhb.code ? outcomeDhb.code : outcomeDhb.name;
		$scope.dhbIsAvailable = outcomeDhb.isAvailable;
		$scope.isCpacRegistered = outcomeDhb.isCpacRegistered;
		$scope.date = new Date();

		$scope.sanitizerDHBName = function (name) {
			if (!name) {
				return 'Public hospital';
			}
			return name.replace('District Health Board','region');
		};

		/**
		 * A public referral is routed to the patient's DHB. Without a DHB code the
		 * referral can't be routed, so block the public paths and prompt to fix the
		 * address. Private referrals are unaffected.
		 */
		$scope.isDhbUnresolved = function () {
			return !outcomeDhb.code;
		};

		/**
		 * The public CPAC score is calculated from the impact-on-life answers, so a public
		 * referral cannot be completed until a current set has been recorded against this
		 * referral - without any the backend fails with a server error, and answers older
		 * than the validity window no longer describe the patient in the chair. Both cases
		 * leave the public option as "go and answer the questions".
		 *
		 * CP.eligibilitySummaryFirstLoad is not a substitute: it only tracks whether the
		 * questionnaire screen has been opened during this session, it is not reset between
		 * referrals for the same patient, and it used to flip on arrival at the form rather
		 * than on submission. Ask the referral itself instead.
		 */
		$scope.hasCurrentImpactOnLife = function () {
			return $scope.CR.hasCurrentImpactOnLife();
		};

		// Whether the answers this referral carries have aged out, and when they were
		// given - the summary shows the date so the practice can see what the score above
		// is based on, and says so explicitly when they are too old to count.
		$scope.isImpactOnLifeExpired = function () {
			return $scope.CR.isImpactOnLifeExpired();
		};

		$scope.impactOnLifeDate = function () {
			return $scope.CR.impactOnLifeDate();
		};

		// Exposed for the template's wording of the expiry notice.
		$scope.impactOnLifeValidMonths = IMPACT_ON_LIFE_VALID_MONTHS;

		function showDhbUnresolvedModal() {
			$scope.generalModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.general.tpl.html",
				show: true,
				title: "Patient's DHB could not be determined",
				content: "This patient's DHB could not be determined from their address, so a public referral cannot be submitted. Please update the patient's address and try again.",
				backdrop: true,
				keyboard: false,
			});
		}

		function showImpactOnLifeRequiredModal() {
			var expired = $scope.isImpactOnLifeExpired();
			$scope.generalModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.general.tpl.html",
				show: true,
				title: expired ? "Impact on life answers are out of date" : "Impact on life questions not completed",
				content: expired
					? "The impact on life answers on this referral are more than " + IMPACT_ON_LIFE_VALID_MONTHS + " months old, so they can no longer be used to score a public referral. Please answer the questions again and try again."
					: "The impact on life questions have to be answered before this referral can be sent to a public hospital. Please complete them and try again.",
				backdrop: true,
				keyboard: false,
			});
		}

		$scope.onGeneralClick = function () {
			if ($scope.generalModal) {
				$scope.generalModal.hide();
			}
		};

		$scope.filterData = {
			showAll: false
		};
		$scope.selectedDoc = null;


		$scope.showSouthernCrossLine = function (patient) {
			return Insurance.has(patient, 'SOUTHERN_CROSS') || Insurance.has(patient, 'AIA');
		}

		$scope.showOtherInsuranceLine = function (patient) {
			return Insurance.has(patient, 'NIB') || Insurance.has(patient, 'AA') || Insurance.has(patient, 'PARTNERS_LIFE')
				|| Insurance.has(patient, 'ACCURO') || Insurance.has(patient, 'OTHER');
		}

		$scope.appendInsuranceName = function (patient, isSourthenCross) {
			if(isSourthenCross) {
				if(Insurance.has(patient, 'SOUTHERN_CROSS')) return 'Southern Cross';
				if(Insurance.has(patient, 'AIA')) return 'AIA';
				return 'Southern Cross or AIA'
			} else {
				if(Insurance.has(patient, 'NIB')) return 'NIB';
				if(Insurance.has(patient, 'AA')) return 'AA';
				if(Insurance.has(patient, 'PARTNERS_LIFE')) return 'Partners life';
				if(Insurance.has(patient, 'ACCURO')) return 'Accuro';
				if(Insurance.has(patient, 'OTHER')) return 'Other';
				return 'NIB, AA, Partners life, Accuro and other'
			}
		}


		$scope.hiddenEmptyString = function (str) {
			return str ? 'NHI: '+str : '';
		}

		$scope.isEligibleSouthernCrossOrAIA = function (patient){
            return !!($scope.CR.referral.outcome && $scope.CR.referral.outcome.isEligibleSouthernCross) && (Insurance.has(patient, 'SOUTHERN_CROSS') || Insurance.has(patient, 'AIA'));
		}

		$scope.isEligibleOtherInsurance = function (patient) {
			return (Insurance.has(patient, 'NIB') || 
			Insurance.has(patient, 'AA') || 
			Insurance.has(patient, 'PARTNERS_LIFE') || 
			Insurance.has(patient, 'ACCURO') || 
			Insurance.has(patient, 'OTHER')) && !!($scope.CR.referral.outcome && $scope.CR.referral.outcome.isEligiblePrivateOtherInsurance);
		}

		$scope.selectDoctor = function(doc) {
			$scope.selectedDoc = doc;
		};

		function resetFormData() {
			$scope.formData = {
				comments: ($scope.CR.referral.outcome || {}).additionalComments,
				isOverride: false,
				referralSystem: ""
			};
			$scope.selectedDoc = null;
			$scope.showDocWarning = false;
			$scope.filterData.showAll = false;
			$scope.displayOptomsArray = $scope.doctorsDhbArray;
		}

		// get list of doctors here
		$scope.US.getOphByReferralType('CATARACT').then(
			function(resp) {
				$scope.doctorsArray = resp.data;

				var dhbCode = $scope.dhbCode ? $scope.dhbCode.toLowerCase() : null;

				$scope.doctorsArray.forEach(function(doc) {
					if (dhbCode && doc.dhbName && doc.dhbName.toLowerCase() === dhbCode) {
						$scope.doctorsDhbArray.push(doc);
					}
				});

				$scope.displayOptomsArray = $scope.doctorsDhbArray;
			},
			function(err) {
				console.error(err && err.status);
			}
		);

		$scope.displayDoctors = function(bool) {
			$scope.filterData.showAll = bool;
			if ($scope.filterData.showAll === true) {
				$scope.displayOptomsArray = $scope.doctorsArray;
			} else {
				$scope.displayOptomsArray = $scope.doctorsDhbArray;
			}
		};

		$scope.showCompleteReferralModal = function(referralSystem) {
			if (referralSystem === "PUBLIC_SYSTEM" && $scope.isDhbUnresolved()) {
				showDhbUnresolvedModal();
				return;
			}
			if (referralSystem === "PUBLIC_SYSTEM" && !$scope.hasCurrentImpactOnLife()) {
				showImpactOnLifeRequiredModal();
				return;
			}
			resetFormData();
			$scope.formData.referralSystem = referralSystem;
			$scope.completeReferralModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.complete-referral.tpl.html",
				show: true,
				title: "COMPLETE REFERRAL"
			});
			// randomise array here
			$scope.doctorsDhbArray = shuffle($scope.doctorsDhbArray);
		};

		$scope.showCompleteOverrideModal = function(referralSystem) {
			if (referralSystem === "PUBLIC_SYSTEM" && $scope.isDhbUnresolved()) {
				showDhbUnresolvedModal();
				return;
			}
			if (referralSystem === "PUBLIC_SYSTEM" && !$scope.hasCurrentImpactOnLife()) {
				showImpactOnLifeRequiredModal();
				return;
			}
			resetFormData();
			$scope.formData.isOverride = true;
			$scope.formData.referralSystem = referralSystem;
			$scope.completeReferralModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.override.tpl.html",
				show: true,
				title: "OVERRIDE REFERRAL"
			});
		};

		$scope.sendReferral = function(formData) {
			// Last line of defence - the buttons and the modal openers already check this.
			// Neither the standard nor the manual completion endpoint can score a public
			// referral without the impact-on-life answers; both fail with a generic server
			// error rather than something the practice can act on.
			if ($scope.formData.referralSystem === "PUBLIC_SYSTEM" && !$scope.hasCurrentImpactOnLife()) {
				if ($scope.completeReferralModal) {
					$scope.completeReferralModal.hide();
				}
				showImpactOnLifeRequiredModal();
				return;
			}
			if ($scope.selectedDoc === null && $scope.formData.referralSystem !== "PUBLIC_SYSTEM") {
				// show warning
				$scope.showDocWarning = true;
				return;
			}
			if ($scope.formData.referralSystem !== "PUBLIC_SYSTEM") {
				formData.referredTo = {
					userId: $scope.selectedDoc.id,
					practiceId: $scope.selectedDoc.practiceId,
				};
			}
			$scope.RA.isProcessing = true;

			if (formData.isOverride === true) {
				delete formData.referredTo;
			}

			if ($scope.dhbIsAvailable === "NO" && $scope.formData.referralSystem === "PUBLIC_SYSTEM") {
				// Manual referral API
				const body = {...formData,referredByPracticeId: Session.practice.id};
				$scope.RA.completeManual(body).then(
					function(resp) {
						// download pdf
						downloadFile(
							resp.data,
							"CatTrax_" +
								$scope.CR.referral.id +
								"_" +
								$scope.CP.patient.firstName +
								$scope.CP.patient.lastName +
								"_" +
								getDateString() +
								".pdf"
						);
						$scope.RA.isProcessing = false;
						$scope.completeReferralModal.hide();
						$scope.successOverrideModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.successful-override.tpl.html",
							show: true,
							title: "SUCCESS",
							backdrop: "static",
							keyboard: false
						});
					},
					function(err) {
						console.error(err && err.status);
						$scope.RA.isProcessing = false;
						showErrorModal();
					}
				);
			} else {
				// Standard referral API
				const body = {...formData,referredByPracticeId: Session.practice.id};
				$scope.RA.complete(body).then(
					function(resp) {
						downloadFile(
							resp.data,
							"CatTrax_" +
								$scope.CR.referral.id +
								"_" +
								$scope.CP.patient.firstName +
								$scope.CP.patient.lastName +
								"_" +
								getDateString() +
								".pdf"
						);
						$scope.RA.isProcessing = false;
						$scope.completeReferralModal.hide();
						$scope.successOverrideModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.successful-override.tpl.html",
							show: true,
							title: "SUCCESS",
							backdrop: "static",
							keyboard: false
						});
					},
					function(err) {
						console.error(err && err.status);
						$scope.RA.isProcessing = false;
						showErrorModal();
					}
				);
			}
		};

		function showErrorModal () {
			$scope.serverErrorModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
				show: true,
				title: "CatTrax has encountered an error",
			});
		}

		$scope.startAgain = function() {
			$scope.successOverrideModal.hide();
			$scope.CP.clearPatientResult();
			$state.go("patient-dashboard");
		};

		$scope.backToDashboard = function() {
			$scope.successOverrideModal.hide();
			//$window.history.back();
			$state.go("patient-dashboard");
		}

		$scope.sendOverrideDetails = function() {
			$scope.overrideModal.hide();
			$scope.successOverrideModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.successful-override.tpl.html",
				show: true,
				title: "SUCCESS"
			});
		};

		$scope.gotoIOL = function() {
			// Checked at the entry point so the user isn't sent through the impact
			// questions only to be blocked at submission.
			if ($scope.isDhbUnresolved()) {
				showDhbUnresolvedModal();
				return;
			}
			$state.go("refer.impact");
		};

		$scope.searchPatient = function() {
			$state.go("patient-dashboard");
		}

		$scope.isReferBtnDisabled = function(){
			return !Session.hasPermission("CLINICAL_REFERRAL_UPDATE");
		}

		function downloadFile(data, filename, mime, bom) {
			// https://github.com/kennethjiang/js-file-download/blob/master/file-download.js
			var blobData = typeof bom !== "undefined" ? [bom, data] : [data];
			var blob = new Blob(blobData, { type: "application/pdf" });
			if (typeof window.navigator.msSaveBlob !== "undefined") {
				// IE workaround for "HTML7007: One or more blob URLs were
				// revoked by closing the blob for which they were created.
				// These URLs will no longer resolve as the data backing
				// the URL has been freed."
				window.navigator.msSaveBlob(blob, filename);
			} else {
				var blobURL = window.URL.createObjectURL(blob);
				var tempLink = document.createElement("a");
				tempLink.style.display = "none";
				tempLink.href = blobURL;
				tempLink.setAttribute("download", filename);

				// Safari thinks _blank anchor are pop ups. We only want to set _blank
				// target if the browser does not support the HTML5 download attribute.
				// This allows you to download files in desktop safari if pop up blocking
				// is enabled.
				if (typeof tempLink.download === "undefined") {
					tempLink.setAttribute("target", "_blank");
				}

				document.body.appendChild(tempLink);
				tempLink.click();
				document.body.removeChild(tempLink);
				window.URL.revokeObjectURL(blobURL);
			}
		}

		function getDateString() {
			var date = new Date();
			var dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
				.toISOString()
				.split("T")[0]
				.split("-")
				.join("");
			return dateString;
		}

		function shuffle(array) {
			var currentIndex = array.length,
				temporaryValue,
				randomIndex;
			// While there remain elements to shuffle...
			while (0 !== currentIndex) {
				// Pick a remaining element...
				randomIndex = Math.floor(Math.random() * currentIndex);
				currentIndex -= 1;
				// And swap it with the current element.
				temporaryValue = array[currentIndex];
				array[currentIndex] = array[randomIndex];
				array[randomIndex] = temporaryValue;
			}
			return array;
		}
	}
]);
